import { luscinia } from "./luscinia";

// Displays a notification
luscinia.showNotification = function (title, text, className) {
    const allowedTextLength = 350;
    const allowedTitleLength = 50;

    if (text.length > allowedTextLength) {
        text = text.substring(0, allowedTextLength) + "...";
    }

    if (title.length > allowedTitleLength) {
        title = title.substring(0, allowedTitleLength) + "...";
    }

    ($ as any).gritter.add({
        title: title,
        text: text,
        class_name: className,
        position: luscinia.config.notification.position,
        time: luscinia.config.notification.duration.toString()
    });
};

luscinia.showNotificationModal = function (title:string, text: string) {
    var dialog = luscinia.confirmDialog;
    const $warningModalContainer = $(dialog.identifier.modalWarning);
    $warningModalContainer.find(dialog.identifier.title).text(title);
    if (luscinia.isHTML(text)) {
        $warningModalContainer.find(dialog.identifier.text).html(text);
    }
    else {
        $warningModalContainer.find(dialog.identifier.text).text(text);
    }
    $warningModalContainer.modal("show");

    luscinia.UpdateModalZIndex(dialog);
}